import React, { useEffect, useState } from "react";
import PathWastageinsertion from "./PathWastageinsertion";
import axios from "axios";
import PathWastageUpdate from "./PathWastageUpdate";

const PathWastageMaster = () => {
  const [active, setActive] = useState("insert");
  const [stations, setStations] = useState([]);
  const [machineData, setMachineData] = useState([]);
  const [machineName, setMachineName] = useState([]);
  const [addNewType, setAddNewType] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);
  const [rawMData, setRawMData] = useState([]);
  const [error, setError] = useState(false);
  const [reason, setReason] = useState([]);

  const [loading, setLoading] = useState(false);
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const fetchstation = async () => {
    try {
      const response = await axios.get(`${urlBlockPrefix}getstationcode`);

      if (response.data.status === "ok") {
        const fetchedData = response.data.data;
        setStations(fetchedData);
      }
      return [];
    } catch (err) {
      console.error(`Failed to fetch stations for section:`, err);
      setError(true);
      return [];
    }
  };

  const fetchMachineData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlBlockPrefix}getmachinetype`);
      if (response.data.status === "ok") {
        const raw = response.data.machineTypes;
        setRawMData(raw);
        setDataUpdated(false);
        const flattened = raw.flatMap((o) =>
          o.children.flatMap((obj) =>
            obj.children.flatMap((object) =>
              object.data.flatMap((ob) => ob.ASSET_DISCRIPTION)
            )
          )
        );

        setMachineData(flattened);
        // setMachineData(response.data.machineTypes);
      }
    } catch (err) {
      console.error("Failed to fetch machine types:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  const fetchReason = async () => {
    try {
      const response = await axios.get(`${urlBlockPrefix}getTableDropDown`);
      if (response.data.status === "ok") {
        const fetchedData = response.data.data;
        setReason(fetchedData);
      }
      return [];
    } catch (err) {
      console.error(`Failed to fetch stations for section:`, err);
      setError(true);
      return [];
    }
  };

  useEffect(() => {
    fetchReason();
  }, []);
  const filteredReason = reason.filter((o) => o.tabel_path === "t_path");
  useEffect(() => {
    fetchstation();
    fetchMachineData();
  }, []);
  useEffect(() => {
    if (dataUpdated) {
      fetchMachineData();
    }
  }, [dataUpdated]);

  return (
    <div style={{ minHeight: "90vh" }} className="papaDiv">
      <div className="row m-5">
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => {
              setActive("insert");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "insert" && "active"
            }`}
          >
            Insert
          </button>
          <button
            onClick={() => {
              setActive("update");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "update" && "active"
            }`}
          >
            Update
          </button>
          <hr />
        </div>
      </div>

      <div className="row">
        {active === "insert" ? (
          <div className="">
            <PathWastageinsertion
              stations={stations}
              machineData={machineData}
              addNewType={addNewType}
              setAddNewType={setAddNewType}
              rawMData={rawMData}
              setDataUpdated={setDataUpdated}
              filteredReason={filteredReason}
            />
          </div>
        ) : (
          <div className="">
            <PathWastageUpdate
              stations={stations}
              machineData={machineData}
              filteredReason={filteredReason}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default PathWastageMaster;
